import React from 'react';
import { HeroSection } from '../components/trimora/HeroSection';
import { SocialProofBar } from '../components/trimora/SocialProofBar';
import { MediaMentionsSection } from '../components/trimora/MediaMentionsSection';
import { ProblemSection } from '../components/trimora/ProblemSection';
import { SolutionSection } from '../components/trimora/SolutionSection';
import { HowItWorksSection } from '../components/trimora/HowItWorksSection';
import { IngredientsSection } from '../components/trimora/IngredientsSection';
import { ForYouSection } from '../components/trimora/ForYouSection';
import { ComparisonSection } from '../components/trimora/ComparisonSection';
import { TestimonialsSection } from '../components/trimora/TestimonialsSection';
import { UrgencySection } from '../components/trimora/UrgencySection';
import { PricingSection } from '../components/trimora/PricingSection';
import { GuaranteeSection } from '../components/trimora/GuaranteeSection';
import { FAQSection } from '../components/trimora/FAQSection';
import { FinalCTASection } from '../components/trimora/FinalCTASection';
import { FooterDisclaimer } from '../components/trimora/FooterDisclaimer';
const marqueeItems = ['⭐⭐⭐⭐⭐ "Perdí 7 kg en 3 semanas" — Ana R.', '◆ 🔥 +10.000 clientas satisfechas en España', '◆ ⭐⭐⭐⭐⭐ "Mi barriga desapareció" — Carmen L.', '◆ ✅ Garantía 90 días sin preguntas', '◆ ⭐⭐⭐⭐⭐ "-12 cm de cintura en 30 días" — Laura M.', '◆ 🚚 Envío gratis a toda España', '◆ ⭐⭐⭐⭐⭐ "El mejor producto que he probado" — Sofía G.', '◆ 🏆 Producto #1 en metabolismo natural', '◆ ⭐⭐⭐⭐⭐ "Resultados desde el día 7" — María J.', '◆ 🔒 Pago 100% seguro · SSL 256-bit'];
export function TrimoraLanding() {
  return <div className="w-full min-h-screen bg-background" data-id="element-676">
      {/* 1. Red urgency flash bar */}
      <div className="bg-red-600 text-white text-center py-2 px-4 text-sm font-medium" data-id="element-677">
        ⚡ OFERTA FLASH: Envío GRATIS + Descuento Especial Activo ·{' '}
        <span className="text-green-300 font-bold" data-id="element-678">
          Solo quedan 23 unidades
        </span>{' '}
        ⚡
      </div>

      {/* 2. Scrolling green marquee ticker */}
      <div className="bg-green-700 text-white py-2 overflow-hidden" data-id="element-679">
        <div className="flex whitespace-nowrap animate-marquee" data-id="element-680">
          {[...marqueeItems, ...marqueeItems].map((item, i) => <span key={i} className="inline-block px-4 text-sm font-medium" data-id="element-681">
              {item}
            </span>)}
        </div>
      </div>

      {/* 3. Sticky nav */}
      <nav className="sticky top-0 z-50 bg-white border-b border-border shadow-sm" data-id="element-682">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex items-center justify-between gap-4" data-id="element-683">
          <span className="text-xl font-bold text-green-700 tracking-tight" data-id="element-684">
            🌿 Trimora
          </span>
          <div className="hidden sm:flex items-center gap-2 text-sm text-foreground" data-id="element-685">
            <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse" data-id="element-686"></span>
            <span className="font-medium" data-id="element-687">23 unidades restantes</span>
          </div>
          <a href="#pricing" className="bg-green-600 hover:bg-green-700 text-white font-bold text-sm px-5 py-2 rounded-full transition-colors duration-200 shadow-sm whitespace-nowrap" data-id="element-688">
            🛒 Comprar Ahora
          </a>
        </div>
      </nav>

      {/* Main content */}
      <main data-id="element-689">
        <HeroSection data-id="element-690" />
        <SocialProofBar data-id="element-691" />
        <MediaMentionsSection data-id="element-692" />
        <ProblemSection data-id="element-693" />
        <SolutionSection data-id="element-694" />
        <HowItWorksSection data-id="element-695" />
        <IngredientsSection data-id="element-696" />
        <ForYouSection data-id="element-697" />
        <ComparisonSection data-id="element-698" />
        <TestimonialsSection data-id="element-699" />
        <UrgencySection data-id="element-700" />
        <div id="pricing" data-id="element-701">
          <PricingSection data-id="element-702" />
        </div>
        <GuaranteeSection data-id="element-703" />
        <FAQSection data-id="element-704" />
        <FinalCTASection data-id="element-705" />
      </main>

      <FooterDisclaimer data-id="element-706" />
    </div>;
}